// El gimnasio cobra por mes calendario: un período nuevo se propone del día 1 al día 1 del mes
// siguiente (fin sin incluir). Todo se calcula con fechas "AAAA-MM-DD" como texto, sin aritmética
// de Date, para que ninguna medianoche UTC corra el período un día.

const DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

function pad(value, length = 2) {
  return String(value).padStart(length, '0');
}

/** Fecha de hoy en Argentina ("AAAA-MM-DD"), que es la que usa el servidor para vencimientos. */
export function todayInArgentina(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Argentina/Buenos_Aires', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(now);
  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
  return `${values.year}-${values.month}-${values.day}`;
}

/** Día 1 del mes de `date`. Devuelve '' si la fecha no es válida. */
export function firstOfMonth(date) {
  const match = DATE_PATTERN.exec(date || '');
  return match ? `${match[1]}-${match[2]}-01` : '';
}

/** Día 1 del mes siguiente al de `date` (fin "sin incluir" de un mes calendario). */
export function firstOfNextMonth(date) {
  const match = DATE_PATTERN.exec(date || '');
  if (!match) return '';
  const year = Number(match[1]);
  const month = Number(match[2]);
  return month === 12 ? `${pad(year + 1, 4)}-01-01` : `${pad(year, 4)}-${pad(month + 1)}-01`;
}

/**
 * Propone el próximo mes calendario sin cubrir: el mes actual o, si el socio ya tiene un período
 * vigente (no anulado) que pisa ese mes, el primero siguiente que esté libre.
 */
function monthIsTaken(taken, startDate, endDate) {
  return taken.some((membership) => startDate < membership.endDate && endDate > membership.startDate);
}

export function proposeCalendarPeriod(memberships, today) {
  let startDate = firstOfMonth(today);
  if (!startDate) return { startDate: '', endDate: '' };
  const taken = (memberships || []).filter((membership) => membership && membership.status !== 'voided'
    && DATE_PATTERN.test(membership.startDate || '') && DATE_PATTERN.test(membership.endDate || ''));
  // Tope defensivo: nadie tiene diez años de períodos cargados por adelantado.
  for (let guard = 0; guard < 120; guard += 1) {
    const endDate = firstOfNextMonth(startDate);
    if (!monthIsTaken(taken, startDate, endDate)) return { startDate, endDate };
    startDate = endDate;
  }
  return { startDate, endDate: firstOfNextMonth(startDate) };
}
